import { Modal } from '@mantine/core';
import { useIntl } from 'react-intl';

import { getHelpModalMessages } from './get-help-modal-messages';
import { GetHelpModalContent } from './GetHelpModalContent';

import type { GetHelpModalProps } from './get-help-modal-types';

export const GetHelpModal = ({ opened, onClose, zIndex, ...contentProps }: GetHelpModalProps) => {
  const intl = useIntl();

  return (
    <Modal onClose={onClose} opened={opened} title={intl.formatMessage(getHelpModalMessages.title)} zIndex={zIndex}>
      <GetHelpModalContent onClose={onClose} zIndex={zIndex} {...contentProps} />
    </Modal>
  );
};
